import lazyLoading from "./lazyLoading";

export default {
  name: "kontrole",
  meta: {
    default: false,
    expanded: false,
    title: "Kontrole",
    class: "primary",
    show: false,
    iconClass: "fa fa-check-square-o"
  },

  children: [
    {
      name: "kontrole-pregled",
      path: "/kontrole/pregled",
      component: lazyLoading("kontrole/pregled/pregled"),
      meta: {
        title: "Pregled",
        requiredAuth: true
      }
    },
    {
      name: "kontrole-postavke",
      path: "/kontrole/postavke",
      component: lazyLoading("kontrole/postavke/postavke"),
      meta: {
        title: "Postavke",
        requiredAuth: true
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./src/store/modules/menu/kontrole.js